import React, { useMemo, useState } from 'react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { Tile, Select, SelectOption, notification } from '@cv/eds-react';
import { AgGridReact } from 'ag-grid-react';
import { Button } from '@dsi/react-eds';
import useGetSeverityRules from '../../hooks/useGetSeverityRules';
import useCustomerData from '../../Context/CustomerDataContext';
import { Modal } from 'react-bootstrap';
import useGetSeverityTypes from '../../hooks/useGetSeverityTypes';
import useDeleteSeverityRule from '../../hooks/useDeleteSeverityRule';
import { useHistory } from 'react-router-dom';

const SeverityRules = () => {
  const { customer } = useCustomerData();
  const history = useHistory();
  const [severityTypesDialog, setSeverityTypesDialog] = useState(false);
  const [selectedSeverityType, setSelectedSeverityType] = useState('');
  const [deleteConnfirmationDialog, setDeleteConnfirmationDialog] = useState(false);
  const [selectedSeverityRule, setSelectedSeverityRule] = useState(null);
  const { mutateAsync } = useDeleteSeverityRule(customer);

  const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);
  const containerStyle = useMemo(() => ({ height: '60vh', width: '100%' }), []);

  const [gridApi, setGridApi] = useState(null);
  const { data, refetch } = useGetSeverityRules(customer);
  const { data: severityTypes } = useGetSeverityTypes(customer);

  const columnDefs = [
    { field: 'name' },
    { field: 'type' },
    { field: 'priority' },
    { field: 'active' },
    {
      field: 'actions',
      cellRenderer: ActionBtns,
      width: 100
    }
  ];

  const addButton = (
    <Button
      icon="plus"
      onClick={() => {
        setSeverityTypesDialog(true);
      }}
    >
      Add Severity Rule
    </Button>
  );

  const onGridReady = (params) => {
    if (params.api) {
      setGridApi(params.api);
    }
  };

  const handleEditBtn = (e) => {
    history.push('/severity-rules/edit/' + e.id);
  };

  const handleDeleteBtn = (e) => {
    setDeleteConnfirmationDialog(true);
    setSelectedSeverityRule(e);
  };

  const handleSeverityTypesModalClosed = () => {
    setSeverityTypesDialog(false);
    setSelectedSeverityType('');
  };

  const handleSeverityRuleSelected = () => {
    setSeverityTypesDialog(false);
    history.push({
      pathname: '/severity-rules/add',
      state: selectedSeverityType
    });
  };

  const handleDeleteDialogClosed = () => {
    setDeleteConnfirmationDialog(false);
    setSelectedSeverityRule(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedSeverityRule) {
      await mutateAsync(selectedSeverityRule.id);
      setDeleteConnfirmationDialog(false);
      setSelectedSeverityRule(null);
      await refetch();
      notification.notice('Severity Rule deleted successfully!!!');
    }
  };

  return (
    <div>
      <Tile id="tile-severity-rules" title="Severity Rules" extra={[addButton]}>
        <div style={containerStyle}>
          <div style={gridStyle} className="ag-theme-alpine ag-style">
            <AgGridReact
              onGridReady={onGridReady}
              columnDefs={columnDefs}
              rowData={data?.data}
              rowSelection="single"
              excelStyles={[
                {
                  id: 'indent-1',
                  alignment: { indent: 1 },
                  dataType: 'string'
                }
              ]}
              overlayNoRowsTemplate="No Data"
              overlayLoadingTemplate={'<div class="loading"></div>'}
              context={{
                handleEditBtn,
                handleDeleteBtn
              }}
              defaultColDef={{
                sortable: true,
                filter: false,
                resizable: true,
                flex: 1,
                minWidth: 80,
                floatingFilter: false
              }}
            />
          </div>
        </div>
        <Modal
          show={severityTypesDialog}
          onHide={handleSeverityTypesModalClosed}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Select Severity type</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <p>Please select the severity type you want to add?</p>
              <Select
                value={selectedSeverityType}
                onChange={(value) => setSelectedSeverityType(value[0])}
                placeholder="Select option"
                className="w-100"
              >
                {severityTypes?.data?.map((j) => (
                  <SelectOption key={j} value={j} children={<span>{j}</span>} />
                ))}
              </Select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleSeverityTypesModalClosed}>Cancel</Button>
            <Button disabled={!selectedSeverityType} onClick={handleSeverityRuleSelected}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={deleteConnfirmationDialog}
          onHide={handleDeleteDialogClosed}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete Severity</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Do you want to delete this severity rule?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleDeleteDialogClosed}>Cancel</Button>
            <Button onClick={handleConfirmDelete}>Delete</Button>
          </Modal.Footer>
        </Modal>
      </Tile>
    </div>
  );
};

const ActionBtns = (props) => {
  const buttonEditClicked = () => {
    props.context.handleEditBtn(props.node.data);
  };
  const buttonDeleteClicked = () => {
    props.context.handleDeleteBtn(props.node.data);
  };
  return (
    <div className="d-flex w-100 justify-content-around h-100 align-items-center">
      <Button
        iconOnly
        icon="edit"
        title="Edit Severity Rules"
        onClick={() => buttonEditClicked()}
        className="mr-2 ml-2"
      />
      <Button
        iconOnly
        icon="trashcan"
        title="Delete Severity Rules"
        onClick={() => buttonDeleteClicked()}
        className="mr-2 ml-2"
      />
    </div>
  );
};

export default SeverityRules;
